
<template>
  <!--住户信息-->
  <div>
    <div class="advanced-form">
      <div class="card">
        <div class="card-head">
          <h3>{{roomName}}</h3>
        </div>
        <div class="card-body">
          <x-tabula
            ref="table"
            :columns="columns"
            rowKey="householderInfoId"
            :rowOptList="rowOptList"
            :listApi="listApi"
            :searchParams.sync="searchParams"
            :deleteParam="deleteParam"
            :rowSelection="false"
          >
            <template slot="opt_t" slot-scope="{row}">
              <span>{{row.mobilePhone}}</span>
            </template>

            <template slot="opt_o" slot-scope="{row}">
              <span>{{row.expireTime | foreverTime}}</span>
            </template>
          </x-tabula>
        </div>
      </div>
    </div>

    <!--续期的弹窗-->
    <a-modal
      title="续期"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      :width="900"
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form-item label="截止时间" v-bind="$store.state.modal_ItemLayout">
        <a-date-picker v-model="expireTime" format="YYYY-MM-DD"/>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
import Moment from 'moment';
export default {
  name: 'roomInfo',
  data () {
    return {
      roomName: '',
      householderId: '',
      visible: false,
      btnLoading: {loading: false},
      searchParams: {},
      expireTime: Moment(),
      rowOptList: [
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:householder:remove'] },
        { text: '续期', handle: (record) => this.handleExpire(record), permi: ['community:householder:expire'] }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '手机', dataIndex: 'mobilePhone', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '真实姓名', dataIndex: 'householdName', align: 'left', width: '' },
        { title: '住户类型', dataIndex: 'householdTypeDesc', align: 'left', width: '' },
        { title: '有效期至', dataIndex: 'expireTime', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      listApi: {
        url: `/room/householder/${this.$route.query.id}`,
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/room/householder/',
        // param: { pk_key: 'householderInfoId', pk_val: '' },
        title: '住户',
        key: 'nickName'
      }
    };
  },
  created () {
    this.roomName = this.$route.query.roomName;
  },
  mounted () {
  },
  methods: {
    /* 打开弹窗 */
    handleExpire (row) {
      this.householderId = row.householderInfoId;
      this.expireTime = Moment(row.expireTime);
      this.visible = true;
    },
    /* 提交表单 */
    handleSubmit () {
      let expire = this.expireTime.format('YYYY-MM-DD');
      this.$put({
        url: `/room/expire/${this.householderId}`,
        params: { expireTime: expire },
        btnLoading: this.btnLoading
      }).then((res) => {
        this.visible = false;
        this.$message.success('续期成功！');
        this.$refs.table.getTableList();
      }).catch(() => {
        this.visible = false;
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
